import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function bico(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@bico/FIND_BICO':
      case '@bico/UPDATE_BICO':
      case '@bico/DELETE_BICO':
      case '@bico/STORE_BICO':
      case '@bico/BICOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@bico/SUCCESS_REMOVE':
      case '@bico/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@bico/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.bicos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@bico/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.bico;
        break;
      }

      case '@bico/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        draft.data = [];
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
